import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Logger from './services/logger';

// Global error handler for ChunkLoadError
window.addEventListener('error', (event) => {
  const error = event.error || event.message;
  if (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Loading chunk') ||
    event.message?.includes('chunk')
  ) {
    // Force a hard reload to clear stale chunks
    Logger.warn('ChunkLoadError detected, reloading page...', { error });
    window.location.reload();
  }
});

// Handle unhandled promise rejections (ChunkLoadError can occur in promises)
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('chunk')
  ) {
    // Force a hard reload to clear stale chunks
    Logger.warn('ChunkLoadError in promise rejection, reloading page...', { error });
    event.preventDefault(); // Prevent default error handling
    window.location.reload();
  }
});

const rootElement = document.getElementById('root') as HTMLElement;

// Always use createRoot - prerender script is not working and causes hydration mismatches
// This fixes the flash of HTML issue
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the service worker for PWA support
serviceWorkerRegistration.unregister();
